<template>
  <div class="page_container">
    <div class="page_inner">
      <div class="page_content notice" style="margin-top: 0;">
        <!--보드> 공지사항 Data 리스트-->

        <div class="Tb_data_notice" v-if="processedNoticeList.length > 0">
          <ul>
            <li v-for="(notice, i) in processedNoticeList" :key="i" @click="goDetail(i, notice)">
              <div class="brief-ai-top notice" :class="{ already: !notice.isToday }">
                <h2>
                  {{ notice.title }}
                </h2>
                <img v-if="notice.isToday" src="@/assets/images/brief/brief-active.png" alt="icon" />
                <img v-else src="@/assets/images/brief/brief.png" alt="icon" />
              </div>
              <div class="row-line"></div>
              <div class="brief-ai-bottom notice" :class="{ already: !notice.isToday }">
                <p class="time">{{ notice.Date }} {{ notice.Time }}</p>
                <p>{{ languageMap(notice.language) }}</p>
              </div>
              <!-- </router-link> -->
            </li>
          </ul>
        </div>

        <div class="nodata_com" v-if="noticeList.length === 0">
          {{ $t("brief['noData']") }}
        </div>
      </div>
    </div>
  </div>
  <!--page_container : End-->
</template>

<script>
import { useI18n } from "vue-i18n";
import { mapState, mapActions, mapMutations } from "vuex";
import { getCurrentLocaleTimeHour } from "@/utils/localeTime";

export default {
  name: "Notice",
  data() {
    return {
      Language: localStorage.getItem("patchLang") || "default",
      // listNotice: [],
    };
  },
  setup() {
    const { locale } = useI18n({ useScope: "global" });

    return {
      locale,
    };
  },
  beforeMount() {
    this.connectNotice();
  },
  computed: {
    ...mapState("board", ["noticeList", "langSelect"]),
    nowTime() {
      return getCurrentLocaleTimeHour();
    },
    todayFormatted() {
      if (!this.nowTime || !this.nowTime.Date) return "";
      return this.nowTime.Date.replace(/-/g, ".");
    },
    processedNoticeList() {
      if (!this.noticeList || this.noticeList.length === 0) return [];
      
      return this.noticeList.map(item => {
        const itemDate = item.Date 
        
        return {
          ...item,
          // 오늘 날짜와 일치하면 true, 아니면 false
          isToday: itemDate === this.todayFormatted
        };
      });
    },
  },
  methods: {
    ...mapActions("board", ["getBoardNotice", "getNoticeAll"]),
    ...mapMutations("board", ["detailNotice"]),

    async connectNotice() {
      const language = localStorage.getItem("patchLang") || "default";
      
      if (language === "default") {
        await this.getNoticeAll();
        this.listNotice = this.noticeList;
      } else if (language != "default") {
        await this.getBoardNotice();
        this.listNotice = this.noticeList;
      }
    },
    languageMap(lang) {
      const langMap = {
        ko: "한국어",
        ja: "日本語",
        zh: "中文",
        en: "English",
        vi: "Tiếng Việt"
      }

      return langMap[lang]
    },
    goDetail(i, notice) {
      this.$router.push({
        path: `/board/notice-detail/${i}`,
      });
      this.detailNotice(notice);
    },
  },
  watch: {
    // 선택된 언어 변경시마다 작동
    langSelect(newVal, oldVal) {
      if (newVal != oldVal) {
        this.connectNotice();
        this.$router.push("/board/notice");
      }
    },
  },
};
</script>
